import * as React from 'react'
import {
  TextField,
  Autocomplete,
  MenuItem,
  createFilterOptions
} from '@mui/material'
import { array, string, func, object, any } from 'prop-types'
import { useEffect } from 'react'
export default function BaseAutoComplete({
  list = [],
  listLabel,
  Input = TextField,
  inputProps,
  defaultValue,
  onChange = () => {},
  reset = () => {},
  ...rest
}) {
  const lista = list.concat([''])
  const [value, setValue] = React.useState('')

  useEffect(() => {
    if (defaultValue !== undefined) {
      onChange(defaultValue)
      setValue(defaultValue)
    }
  }, [defaultValue])

  reset(() => {
    setValue('')
    onChange({})
  })

  const RenderOptions = (props, option) => {
    return (
      // TODO: REMOVER ESTAS CONSIÇOES E ABORDAR ADAPTAR COMPONENTE PARA IDS FORA DO PADRAO
      <MenuItem
        value={option?.id || option?.id_departamento || option?.id_funcao || ''}
        {...props}
        key={
          option?.id ||
          option?.id_departamento ||
          option?.id_funcao ||
          option?.mes ||
          0
        }
      >
        {option !== undefined && option[listLabel]}
      </MenuItem>
    )
  }

  const RenderInput = params => {
    return <Input size="small" {...params} {...inputProps} />
  }
  const OPTIONS_LIMIT = 10
  const defaultFilterOptions = createFilterOptions()

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state).slice(0, OPTIONS_LIMIT)
  }

  return (
    <Autocomplete
      filterOptions={filterOptions}
      style={{ width: '100%' }}
      size="small"
      {...rest}
      disablePortal={false}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue)
        onChange(newValue || {})
      }}
      isOptionEqualToValue={(option, value) => {
        return (
          option[listLabel] === value ||
          value === '' ||
          option === value ||
          true
        )
      }}
      getOptionLabel={option => {
        if (lista[option]) {
          return lista[option][listLabel]
        }
        if (typeof option === 'string') {
          return option
        }

        return option[listLabel]
      }}
      options={lista}
      renderInput={RenderInput}
      renderOption={RenderOptions}
    />
  )
}

BaseAutoComplete.propTypes = {
  list: array,
  listLabel: string,
  Input: func,
  inputProps: object,
  onChange: func,
  defaultValue: any,
  reset: func
}
